class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.inventorydetails = null;
        this.init();
        this.addEventListener("change", this.onVariantChange);
    }
    init() {
        window.addEventListener("load", () => {
            if (!this.inventorydetails) {
                this.inventorydetails = (JSON.parse(document.querySelector("#inventory-details")?.innerHTML || null));
                this.updateOptions();
            }
            console.log("inventorydetails", this.inventorydetails);
        });
    }

    onVariantChange() {
        this.updateOptionsselected();
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();

        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.SlickTrigger();
            this.renderProductInfo();
        }
    }
    SlickTrigger() {
        //triggers slick change
        const SlickTriggerElement = document.querySelector('#trigger_swatchchange');
        SlickTriggerElement.setAttribute('data-current_variant', JSON.stringify(this.currentVariant));
        SlickTriggerElement.value = this.currentVariant.id
        SlickTriggerElement.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }

    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select"),
            (select) => select.value
        );
    }

    getInventrydeatils() {
        this.inventorydetails = (JSON.parse(document.querySelector("#inventory-details")?.innerHTML || null));
        return this.inventorydetails;
    }

    updateMasterId() {
        let alternateVariant = null;
        let checkedselectedvalue = false;
        this.currentVariant = this.getInventrydeatils().find((variant) => {

            let seleted = this.options.findIndex(option => option === this.selectedoption);

            checkedselectedvalue = !variant.options
                .map((option, index) => {
                    if (index == 0 && this.options[index] === option && !alternateVariant) {
                        alternateVariant = variant
                    }
                    return this.options[index] === option

                })
                .includes(false);
            if (checkedselectedvalue) {
                return !variant.options
                    .map((option, index) => {
                        // if(index == 0 && this.options[index] === option && !alternateVariant && (variant.data[0].available != 0 || variant.data[1].available != 0 || variant.backorderdate != null )){	
                        // 	alternateVariant = variant	
                        // }	
                        return this.options[index] === option;
                    })
                    .includes(false);
            }
        });
        if (!this.currentVariant) {
            this.currentVariant = alternateVariant;
        }
        this.currentVariant = this.getVariantData()?.filter((variant) => variant.id == this.currentVariant.variantID)[0];
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (!newMedia) return;
        const parent = newMedia.parentElement;
        parent.prepend(newMedia);
        window.setTimeout(() => {
            parent.scroll(0, 0);
        });
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    renderProductInfo() {
        try {
            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((responseText) => {
                    const id = `ProductInfo-${this.dataset.section}`;
                    const html = new DOMParser().parseFromString(responseText, "text/html");
                    const destination = document.getElementById(id);
                    const source = html.getElementById(id);

                    if (source && destination) destination.innerHTML = source.innerHTML;

                    const infoSectionId = `ProductInfoSection-${this.dataset.section}`;
                    const infoSectionHtml = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                    );
                    const infoSectionDestination = document.getElementById(infoSectionId);
                    const infoSectionSource = infoSectionHtml.getElementById(infoSectionId);

                    if (infoSectionSource && infoSectionDestination)
                        infoSectionDestination.innerHTML = infoSectionSource.innerHTML;

                    document
                        .getElementById(`price-${this.dataset.section}`)
                        ?.classList.remove("visibility-hidden");
                    this.toggleAddButton(
                        !this.currentVariant.available,
                        window.variantStrings.soldOut
                    );
                    if (document.querySelector(".inventory-data_contents") != undefined) {
                        this.renderInventoryData();
                    }

                    var unavailableset = this.getInventrydeatils()
                        .filter((variant) => variant.option1?.trim().replace(' ', '').replace('"', '').toLowerCase() == this.options[0]?.trim().replace(' ', '').replace('"', '').toLowerCase() || variant.option2?.trim().replace(' ', '').replace('"', '').toLowerCase() == this.options[1]?.trim().replace(' ', '').replace('"', '').toLowerCase())

                    if (unavailableset?.length) {
                        if (unavailableset[0]?.options.length == 2) {
                            var unavailablesetResult1 = unavailableset.filter((variantSet) => variantSet?.options[0] === this.currentVariant?.options[0]);
                            var unavailablesetResult2 = unavailableset.filter((variantSet) => variantSet?.options[1] === this.currentVariant?.options[1]);

                            var unavailablesetResult11 = unavailablesetResult1.filter((variantSet) => variantSet?.options[1] === this.currentVariant?.options[1]);
                            var unavailablesetResult22 = unavailablesetResult2.filter((variantSet) => variantSet?.options[0] === this.currentVariant?.options[0]);

                            if (unavailablesetResult11.length == 0 && unavailablesetResult22.length == 0) {

                                var addButton = document
                                    .getElementById(`product-form-${this.dataset.section}`)
                                    ?.querySelector('[name="add"]');
                            } else if (unavailablesetResult11.length == 1 && unavailablesetResult22.length == 1) {

                                if ((unavailablesetResult11[0]?.data[0].available == 0 && unavailablesetResult11[0]?.data[1].available == 0) && (unavailablesetResult11[0]?.backorderdate == null)) {
                                    var addButton = document
                                        .getElementById(`product-form-${this.dataset.section}`)
                                        ?.querySelector('[name="add"]');
                                }

                            } else {
                                var addButton = document
                                    .getElementById(`product-form-${this.dataset.section}`)
                                    ?.querySelector('[name="add"]');
                                addButton?.setAttribute("disabled", false);
                                addButton.textContent = window.variantStrings.addToCart;
                            }
                        }
                    }

                    this.getInventrydeatils()
                        .filter((variant) => variant.option1?.trim().replace(' ', '').replace('"', '').toLowerCase() == this.options[0]?.trim().replace(' ', '').replace('"', '').toLowerCase() || variant.option2?.trim().replace(' ', '').replace('"', '').toLowerCase() == this.options[1]?.trim().replace(' ', '').replace('"', '').toLowerCase())

                });
        } catch (err) {
            console.log(err.message, 'error block')
        }
    }

    renderInventoryData() {
        var currentVariantId = this.currentVariant.id;
        fetch(`https://modway-locations-inventory.azurewebsites.net/api/locationsinventory/${currentVariantId}?code=6cCL0asoqLNZLoWu1E%2FkbZcw2Y2D49mBmpzf59KMIBSLosDgD6mDSQ%3D%3D`)
            .then(response => response.json())
            .then(data => {
                const ldata = data.data
                let contentDiv = document.querySelector('.inventory-data_contents');
                let item = document.createElement('DIV');
                item.classList = 'inventory-data_content';
                if (ldata.length > 0) {
                    contentDiv.innerHTML = '';
                }

                for (let index = 0; index < ldata.length; index++) {
                    let warehouse = item.cloneNode();
                    let name = document.createElement('SPAN');
                    name.innerText = ldata[index].locationname == 'HT' ? "New Jersey" + ':' : "California" + ':';;
                    let value = document.createElement('SPAN');
                    value.innerText = ldata[index].available;
                    warehouse.appendChild(name);
                    warehouse.appendChild(value);

                    if (ldata[index].locationname == 'HT') {
                        if (ldata[index].available <= 0) {
                            let backorderdiv = document.querySelector('.product-type-est.backorder-ht');
                            backorderdiv && warehouse.appendChild(backorderdiv);
                        }
                    } else if (ldata[index].locationname == 'CA') {
                        if (ldata[index].available <= 0) {
                            let backorderdiv = document.querySelector('.product-type-est.backorder-ca');
                            backorderdiv && warehouse.appendChild(backorderdiv);
                        }
                    }
                    contentDiv.appendChild(warehouse);

                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = document
            .getElementById(`product-form-${this.dataset.section}`)
            ?.querySelector('[name="add"]');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute("disabled", true);
            if (text) addButton.textContent = text;
        } else {
            addButton.removeAttribute("disabled");
            addButton.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);

        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptionsselected() {
        const note = this.querySelector('.checkedradio');
        const seletedoption = note.innerHTML;
        this.selectedoption = seletedoption;

    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);